import React from 'react'
import Translation from '../global/Translation'
import ProductTypes from './ProductTypes'

export const getProductDescription = (descriptions, locale) => {
    if (!descriptions || typeof descriptions !== 'object') return null

    const normalizedLocale = (locale || '').toLowerCase()

    return descriptions[normalizedLocale] || descriptions[locale] || descriptions['en-us'] || descriptions.en || Object.values(descriptions)[0] || null
}

export const hasProfessionalProductInfo = (product, locale) => {
    if (!product) return false

    return !!(getProductDescription(product.descriptions, locale) || product.ral)
}

export const hasProfessionalProductDescription = (product, locale) => {

    if (!product) return false

    return !!(getProductDescription(product.descriptions, locale))
}

const ProfessionalProductInfo = ({ product, locale }) => {
    if (!hasProfessionalProductInfo(product, locale)) return null

    const description = getProductDescription(product.descriptions, locale)

    return (
        <div className="professional-product-info">
            {description && (
                <div className="professional-product-info--description">
                    <p>
                        <Translation id="description" defaultMessage="Description" />:
                    </p>
                    <span>{description}</span>
                </div>
            )}
            {product.ral && (
                <React.Fragment>
                    <div className="professional-product-info--ral">
                        <span className="professional-product-info--ral-label">
                            <Translation id="similar_to_ral" defaultMessage="Similar to RAL" />
                            ®:{' '}
                        </span>
                        <span>{product.ral}</span>
                    </div>
                    <div className="professional-product-info--ral">
                        <span className="professional-product-info--ral-copyright">
                            <Translation id="ral_trademark" defaultMessage="RAL is a registered trademark of RAL Deutsches Institut für Gütesicherung und Kennzeichnung e.V." />
                        </span>
                    </div>
                </React.Fragment>
            )}
        </div>
    )
}

export default ProfessionalProductInfo
